import Vue from 'vue'
import Vuex from 'vuex'
import http from '@/utils/request'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: JSON.parse(window.localStorage.getItem('user')) || {}, // 用户信息
    messageCount:window.localStorage.getItem('messageCount') || 0,
    appInfo:JSON.parse(localStorage.getItem('appInfo')) || {},
  },
  getters: {
    userInfo(state) {
      return state.user
    },
  },
  mutations: {
    setUserInfoAsync(state, res) {
        // const data = {...state.user,...res}
        let data=res
        state.user = data;
        window.localStorage.setItem('user',JSON.stringify(data))
        
    },
    setMessageCount(state,count){
        state.messageCount=count
    },
    setAppInfo(state,data){
      window.localStorage.setItem('appInfo',JSON.stringify(data))
      state.appInfo=data

    }
  },
  actions: {
    getUserInfo({
        commit
    }) {
        http.post('/api/personal/user_info').then(res => {
          if (res.code == 1) {
            commit('setUserInfoAsync', res.data);
          }
        });
    },
    getAppInfo({commit}){
      http.post('/api/index/customer_service').then(res=>{
        if(res.code==1){
          commit('setAppInfo',res.data)
        }
      })
    },
  },
  modules: {
  }
})
